import { axios } from '@/utils/request'

const api = {
  customGroupQueryList: '/sso/customGroup/queryList',
  customGroupQuery: '/sso/customGroup/query',
  customGroupAdd: '/sso/customGroup/add',
  customGroupDel: '/sso/customGroup/del',
  customGroupEdit: '/sso/customGroup/edit',
  bindMenuCustomMenu: '/sso/customGroup/bindMenuCustomMenu',
  collectMenu: '/sso/customGroup/collectMenu',
  addFavorites: '/sso/customGroup/addFavorites ', // 新增收藏夹的接口
  delFavorites: '/sso/customGroup/delFavorites ', // 删除收藏夹的接口
  queryFavorites: '/sso/customGroup/queryFavorites' // 查询收藏夹的接口
}
export default api

export const customGroupQueryList = async params => axios.post(api.customGroupQueryList, params)
export const customGroupQuery = async params => axios.post(api.customGroupQuery, params)
export const customGroupAdd = async params => axios.post(api.customGroupAdd, params)
export const customGroupDel = async params => axios.post(api.customGroupDel, params)
export const customGroupEdit = async params => axios.post(api.customGroupEdit, params)
export const bindMenuCustomMenu = async params => axios.post(api.bindMenuCustomMenu, params)
export const collectMenu = async params => axios.post(api.collectMenu, params)
export const addFavorites = async params => axios.post(api.addFavorites, params)
export const delFavorites = async params => axios.post(api.delFavorites, params)
export const queryFavorites = async params => axios.post(api.queryFavorites, params)
